import { Windower } from "./window";
export function camelcaseToSentenceCase(camelcase, uppercaseInitial = true) {
    let result = camelcase.replace(/([A-Z])/g, " $1");
    if (uppercaseInitial) {
        result = result.charAt(0).toUpperCase() + result.slice(1);
    }
    return result;
}
export function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}
export function isUndefinedOrNullOrEmptyString(str) {
    return str === undefined || str === null || str.toString() === "";
}
function extractTermsRecursive(collector, accumulatingTerm, depth, currentCharactersWindow, remainingCharactersWindow, openingDelimiter, closingDelimiter) {
    const currentCharacters = currentCharactersWindow.current();
    if (currentCharacters === null) {
        return collector;
    }
    const currentString = currentCharacters.join("");
    if (currentString === openingDelimiter) {
        return extractTermsRecursive(collector, accumulatingTerm + currentString, depth + 1, currentCharactersWindow.advance(openingDelimiter.length), remainingCharactersWindow.advance(openingDelimiter.length), openingDelimiter, closingDelimiter);
    }
    if (currentString === closingDelimiter) {
        if (depth === 0) {
            return extractTermsRecursive(collector, accumulatingTerm, depth, currentCharactersWindow.advance(openingDelimiter.length), remainingCharactersWindow.advance(openingDelimiter.length), openingDelimiter, closingDelimiter);
        }
        if (depth === 1) {
            collector.push(accumulatingTerm + currentString);
            return extractTermsRecursive(collector, "", depth - 1, currentCharactersWindow.advance(openingDelimiter.length), remainingCharactersWindow.advance(openingDelimiter.length), openingDelimiter, closingDelimiter);
        }
        else {
            return extractTermsRecursive(collector, accumulatingTerm + currentCharacters[0], depth - 1, currentCharactersWindow.advance(1), remainingCharactersWindow.advance(1), openingDelimiter, closingDelimiter);
        }
    }
    if (depth === 0) {
        return extractTermsRecursive(collector, accumulatingTerm, depth, currentCharactersWindow.advance(1), remainingCharactersWindow.advance(1), openingDelimiter, closingDelimiter);
    }
    return extractTermsRecursive(collector, accumulatingTerm + currentCharacters[0], depth, currentCharactersWindow.advance(1), remainingCharactersWindow.advance(1), openingDelimiter, closingDelimiter);
}
function closingDelimiterSeeker(closingDelimiter, openingDelimited) {
    return (collected, characterWindow) => {
        let stringBeingBuilt = "";
        let current = characterWindow.current();
        while (current !== null && current.join("") !== closingDelimiter) {
            stringBeingBuilt = stringBeingBuilt + current[0];
            characterWindow = characterWindow.advance(1);
            current = characterWindow.current();
        }
        if (current === null) {
            return { collected, characterWindow, acceptor: terminalAcceptor() };
        }
        stringBeingBuilt = stringBeingBuilt + current[0];
        collected = [stringBeingBuilt, ...collected];
        return { collected, characterWindow, acceptor: openingDelimiterSeeker(openingDelimited, closingDelimiter) };
    };
}
function terminalAcceptor() {
    const terminal = (collected, characterWindow) => ({
        collected,
        characterWindow,
        acceptor: terminal
    });
    return terminal;
}
function openingDelimiterSeeker(openingDelimiter, closingDelimiter) {
    return (collected, characterWindow) => {
        let current = characterWindow.current();
        while (current !== null && current.join("") !== openingDelimiter) {
            characterWindow = characterWindow.advance(1);
            current = characterWindow.current();
        }
        if (current === null) {
            return { collected, characterWindow, acceptor: terminalAcceptor() };
        }
        return {
            collected,
            characterWindow,
            acceptor: closingDelimiterSeeker(closingDelimiter, openingDelimiter)
        };
    };
}
class Collector {
    constructor() {
        this.depth = 0;
        this.collected = [];
        this.stringBeingBuilt = "";
    }
    push() {
        this.depth = this.depth + 1;
        if (this.depth === 1) {
            this.stringBeingBuilt = "";
        }
    }
    pop() {
        if (this.depth === 1) {
            this.collected = [this.stringBeingBuilt, ...this.collected];
            this.stringBeingBuilt = "";
        }
        this.depth = Math.max(0, this.depth - 1);
    }
    add(s) {
        if (this.depth > 0) {
            this.stringBeingBuilt = this.stringBeingBuilt + s;
        }
    }
    finalCollected() {
        return [...this.collected].reverse();
    }
}
function extractTermsIterative(input, openingDelimiter, closingDelimiter) {
    let characterWindow = new Windower(openingDelimiter.length, input.split(''));
    let current = characterWindow.current();
    let collector = new Collector();
    while (current !== null) {
        const currentString = current.join("");
        if (currentString === openingDelimiter) {
            collector.push();
            collector.add(currentString);
            characterWindow = characterWindow.advance(currentString.length - 1);
        }
        else if (currentString === closingDelimiter) {
            collector.add(currentString);
            collector.pop();
            characterWindow = characterWindow.advance(currentString.length - 1);
        }
        else {
            collector.add(current[0]);
        }
        characterWindow = characterWindow.advance(1);
        current = characterWindow.current();
    }
    return collector.finalCollected();
}
export function extractTerms(input, openingDelimiter, closingDelimiter) {
    if (openingDelimiter.length !== closingDelimiter.length) {
        throw new Error("Length of opening and closing delimiters must be equal");
    }
    return extractTermsIterative(input, openingDelimiter, closingDelimiter);
    // const characters = input.split('')
    // const initialCharsWindow = new Windower(openingDelimiter.length, characters)
    // const remainingCharsWindow = new Windower(openingDelimiter.length, characters, openingDelimiter.length)
    // return extractTermsRecursive([], "", 0, initialCharsWindow, remainingCharsWindow, openingDelimiter, closingDelimiter)
}
export function paragraphs(lines, beginParaPredicate, endParaPredicate) {
    const result = [];
    let currentPara = null;
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        if (endParaPredicate(line) && currentPara !== null) {
            currentPara.push(line);
            result.push(currentPara);
            currentPara = null;
        }
        if (beginParaPredicate(line)) {
            if (currentPara !== null) {
                throw new Error(`nested begin paragraph encountered, line #:${i} '${line}'`);
            }
            else {
                currentPara = [line];
            }
        }
        else if (currentPara !== null) {
            currentPara.push(line);
        }
    }
    return result;
}
export function splitAtFirst(delim, str) {
    const index = str.indexOf(delim);
    if (index === -1) {
        return ["", str];
    }
    const lhs = str.substr(0, index);
    const rhs = str.substr(index + delim.length);
    return [lhs, rhs];
}
export function basename(path) {
    return path.replace(/.*\//, '');
}
export function dirname(path) {
    let match = path.match(/.*\//);
    if (match === null) {
        throw new Error("match is null");
    }
    return match[0];
}
export function mask(header) {
    if (header) {
        return Array.from(header).map((c, index) => index < 4 ? c : "*").join("");
    }
    return null;
}
